const submissionCopyOptions = {
    SUBMISSION_APPLICATION_FORMS : 'Application Forms',

    LIVE_CHAT : 'Live Chat',

    NOTES : 'Notes',

    ATTACHMENTS : 'Attachments',

    REPORTS : 'Reports',

    WORKSHEETS : 'Worksheets',

    EMAILS : 'E-mails',

    ALL : 'All',

    SEPARATOR : ';'

};

angular.module('gw-um-j2js')
    .constant('submissionCopyOptions', submissionCopyOptions);